import React, { useEffect } from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { ImportStatus } from "./components/ImportStatus";
import { MainView } from "./components/MainView";

import "./index.css";
import { UserProvider, useUser } from "./components/UserProvider";
import { SettingsProvider } from "./components/SettingsProvider";
import { createRoot } from "react-dom/client";
import { MainState } from "./components/MainState";
import { getUserPath } from "./utils";

// const CheckAuth = () => {
//   const { auth } = useUser();
//   const location = useLocation();

//   const url = getUserPath(auth);

//   const navigate = useNavigate();
//   useEffect(() => {
//     const url = getUserPath(auth);
//     if (!location.pathname.startsWith(url)) {
//       navigate(url);
//     }
//   }, [auth.username, location, auth.loggedIn]);

//   if (!location.pathname.startsWith(url)) {
//     return <Navigate to={url} />;
//   }

//   return <MainView />;
// };

const SearchView = ({ mode, sets = false }) => {
  return <MainState searchMode={mode} showSetsExport={sets} />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainView />,
    children: [
      { index: true, element: <SearchView mode="meta" /> }
    ]
  },
  // {
  //   path: "/keys",
  //   element: <MainView />,
  //   children: [
  //     { index: true, element: <SearchView mode="key" /> }
  //   ]
  // },
  {
    path: "/collections",
    element: <MainView />,
    children: [
      { index: true, element: <SearchView sets={true} /> }
    ]
  },
  {
    path: "/import",
    element: <MainView />,
    children: [
      { index: true, element: <ImportStatus /> }
    ]
  }
]);

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <MainView/>,
//     children: [<SearchView mode="meta"/>]
//   },
//   {
//     path: "/keys",
//     element: <MainView/>,
//     children: [<SearchView mode="key"/>]
//   },
//   {
//     path: "/collections",
//     element: <MainView/>,
//     children: [<SearchView sets={true}/>]
//   },
//   // {
//   //   path: "/import",
//   //   element: (
//   //     <CheckAuth>
//   //       <ImportStatus/>
//   //     </CheckAuth>
//   //   ),
//   // },
// ]);

const root = createRoot(document.getElementById("root"));

root.render(
  <SettingsProvider>
    <UserProvider>
      <RouterProvider router={router} />
    </UserProvider>
  </SettingsProvider>,
);
